var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['plain-tag yx-pingfang-regular mr-4 font-h6-regular', `plain-tag-${_vm.type}`, _vm.isMarginBottom ? 'mb-4' : '']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }